var antagningsstatistik = window.antagningsstatistik || {};

antagningsstatistik.sokblock = (function ($) {
  var $toolTip;

  function init() {
    $toolTip = $('[data-toggle="tooltip"]');
    initListeners();
  }
  function initListeners() {
    $toolTip.tooltip({ animation: true });
  }
  // 'Public'
  return {
    init: init,
  };
})(jQuery);
// Init when DOM is ready
jQuery(antagningsstatistik.sokblock.init);
